import { useEffect, useState } from 'react'
import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { error } from 'scripts/utils/message'

import { Drawer } from 'lmcv/components/Drawer'
import { WizardForm } from 'lmcv/components/WizardForm'
import { useStep } from 'lmcv/hooks/use-step'
import { getCustomers } from 'lmcv/services/customers'
import { getProfileLoyalty } from 'lmcv/services/profile'
import * as loyaltyStatus from 'lmcv/modules/LoyaltyStatus/constants'

import { List, ListSkeleton } from './components/List'
import { DocumentStatus } from './components/DocumentStatus'
import { JoinProfessional } from './components/JoinProfessional'

function CustomersPage () {
  const [customersLoading, setCustomersLoading] = useState(true)
  const [customers, setCustomers] = useState([])
  const [status, setStatus] = useState(null)
  const [hasProfessionalRelationship, setHasProfessionalRelationship] = useState(false)
  const [statusLoading, setStatusLoading] = useState(true)
  const [professionalData, setProfessionalData] = useState()
  const [prev, next, step, setStep] = useStep(1)
  const [isVisible, setIsVisible] = useState(false)
  const [countRemainingInvites, setCountRemainingInvites] = useState(0)

  const openDrawer = () => setIsVisible(true)

  const closeDrawer = () => {
    setIsVisible(false)
    setStep(1)

    if (step === 3) {
      window.location.reload()
    }
  }

  const ERROR_MESSAGE =
    'Algo inesperado aconteceu ao carregar seu perfil, tente novamente mais tarde.'

  useEffect(() => {
    getProfileLoyalty()
      .then(data => {
        setStatus(data.status)
        setHasProfessionalRelationship(data.hasProfessionalRelationship)
        setStatusLoading(false)

        if (data.professional) {
          setProfessionalData(data.professional)
        }
      })
      .catch(e => {
        error(ERROR_MESSAGE)
      })
  }, [])

  useEffect(() => {
    getCustomers()
      .then(({ data, remainingInvites }) => {
        setCustomers(data)
        setCountRemainingInvites(remainingInvites)
        setCustomersLoading(false)
      })
      .catch(e => {
        error(ERROR_MESSAGE)
      })
  }, [])

  if (!statusLoading) {
    if (status === loyaltyStatus.PRO_EAD_ACTIVE) {
      return (
        <Card title="Clientes">
          {customersLoading
            ? (<ListSkeleton />)
            : (<List data={customers} remainingInvites={countRemainingInvites} onClickAdd={openDrawer} />)
          }

          <Drawer
            title="Adicionar Clientes"
            visible={isVisible}
            onClose={closeDrawer}
          >
            {isVisible &&
              <WizardForm
                prev={prev}
                next={next}
                step={step}
                closeDrawer={closeDrawer}
              />
            }
          </Drawer>
        </Card>
      )
    }

    if (status === loyaltyStatus.PRO_EAD_WITHOUT_DOCUMENTATION) {
      return (
        <JoinProfessional
          status={status}
          hasProfessionalRelationship={hasProfessionalRelationship}
        />
      )
    }

    return (
      <DocumentStatus
        status={status}
        professionalData={professionalData}
        hasProfessionalRelationship={hasProfessionalRelationship}
      />
    )
  }

  return <ListSkeleton />
}

export default CustomersPage
